import React from "react";

interface PageHeaderProps {
  title: React.ReactNode;
  subtitle?: React.ReactNode;
  actions?: React.ReactNode;
}

// Shared page heading: title, optional subtitle, optional actions on the right
const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, actions }) => (
  <header className="page-header">
    <div className="page-header-text">
      <h1 className="page-title">{title}</h1>
      {subtitle && <p className="page-subtitle">{subtitle}</p>}
    </div>
    {actions && <div className="page-actions">{actions}</div>}
  </header>
);

export default PageHeader;
